export default {
  profile: {
    en: 'Profile',
  },
  promotion: {
    en: 'Promotion',
  },
  affiliate: {
    en: 'Affiliate',
  },
  whitepaper: {
    en: 'Whitepaper',
  },
  blog: {
    en: 'Blog',
  },
  about: {
    en: 'About',
  },
}
